<div *ngIf="isActive" class="popup">
  <div [ngClass]="{'popup--full-width' :fullWidth}" class="popup__container">
    <i
      (click)="changeIsActive()"
      *ngIf="showCloseXButton"
      class="popup__icon icon-close"
      data-cy="dialog.close"
    ></i>
    <ng-content></ng-content>
  </div>
</div>
